import React, { useCallback } from 'react';
import { Breakpoint } from '@philips-internal/oswald-ui-constants';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { getBreakpoint, isFunction } from '@philips-internal/oswald-ui-utils';
import { getDynamicContent, getTimelineWidth } from '../timeline-utils.js';
import { TimelineSchedulerEvent } from './timeline-scheduler-event.js';
import './timeline-events.css';
const isMobile = () => {
    const breakpoint = getBreakpoint();
    return breakpoint === Breakpoint.XSM;
};
function TimelineEvents(props) {
    const { data = [], interval, intervals, onClick, onDoubleClick, onDynamicContentRender, superscription, superscriptionEntry } = props;
    const onEventClick = useCallback((event) => {
        if (isFunction(onClick)) {
            onClick(new ClickEvent({ value: event }));
        }
    }, []);
    const onEventDoubleClick = useCallback((event) => {
        if (isFunction(onDoubleClick)) {
            onDoubleClick(new ClickEvent({ value: event }));
        }
    }, []);
    const schedulerEvent = (event) => {
        return (isMobile()
            ? null
            : React.createElement(TimelineSchedulerEvent, { data: event, interval: interval, intervals: intervals, superscription: superscription, superscriptionEntry: superscriptionEntry }));
    };
    const width = isMobile() ? undefined : `${getTimelineWidth(intervals.length)}rem`;
    return (React.createElement("div", { className: "c-timeline-events" }, data.map((event) => {
        return (React.createElement("div", { className: "c-timeline-events__item", key: event.id, onClick: () => onEventClick(event), onDoubleClick: () => onEventDoubleClick(event), style: { width: width } },
            React.createElement("div", { className: "c-timeline-events__event" }, getDynamicContent({ data: event, onDynamicContentRender, type: 'item' })),
            schedulerEvent(event)));
    })));
}
export { TimelineEvents, };
//# sourceMappingURL=timeline-events.js.map